<template>
  <div class="container">
    <div class="error dialog">
      <h3>
        We are sorry, but you do not have access to the Animate Portal. If you
        require access to this portal, your organization admin can acquire a
        subscription to the Animate portal
        <a :href="billing_url">here.</a>
      </h3>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { settings } from "@xsenscloud/xse-styleguide";
import { Configuration } from "@/motion-cloud";

@Component
export default class UnauthorizedView extends Vue {
  public applications = (settings.APPLICATIONS as unknown) as Configuration[];

  public billing_url = this.applications.filter(app => {
    return app.id === "billing";
  })[0].url;
}
</script>

<style lang="scss" scoped>
.dialog {
  max-width: 400px;
  margin: 80px auto;
}
</style>
